<template>
  <a-modal
    title="选择商品"
    style="top: 20px;"
    :width="1200"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-card :bordered="false" :bodyStyle="{ padding: 0}">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item>
                <a-tree-select
                  placeholder="请选择商品类别"
                  treeDefaultExpandAll
                  :treeData="categoryData"
                  treeCheckable
                  @change="onChange"
                  :showCheckedStrategy="SHOW_ALL"
                >
                </a-tree-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item>
                <a-input placeholder="输入商品编号/名称/规格型号等查询" v-model="queryParam.kw"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="仓库">
                <a-select
                  v-model="queryParam.storeId"
                  placeholder="[ 全部 ]"
                >
                  <a-select-option value="0">[ 全部 ]</a-select-option>
                  <a-select-option v-for="item in storeData" :value="item.id" :key="item.id"> {{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select placeholder="请选择" default-value="" v-model="queryParam.status">
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option value="active">启用</a-select-option>
                  <a-select-option value="deleted">禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="tableSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetTableSearch">重置</a-button>
            </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <s-table
        size="middle"
        ref="table"
        rowKey="id"
        :pageSize=10
        :columns="columns"
        :data="loadData"
        bordered
        :rowSelection="options.rowSelection"
        :alert="options.alert"
      >
      <span slot="status" slot-scope="text, record">
        <a-switch
          disabled
          checkedChildren="启用"
          unCheckedChildren="禁用"
          defaultChecked
          v-if="record.status == 'active'"
          @change="statusChange($event, record)"/>
        <a-switch
          disabled
          checkedChildren="启用"
          unCheckedChildren="禁用"
          v-else
          @change="statusChange($event, record)"/>
      </span>

        <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a href="javascript:;">删除</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
      </s-table>
    </a-card>
  </a-modal>
</template>
<script>
import STable from '@/components/table/'
import { getGoodsList } from '@/api/goods'
import { commonStoreList } from '@/api/common'
import { getCategoryGoods } from '@/api/category'
import { TreeSelect } from 'ant-design-vue'
const SHOW_ALL = TreeSelect.SHOW_ALL
export default {
  name: 'GoodsModal',
  components: {
    STable
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    storeList: [Array]
  },
  data () {
    return {
      SHOW_ALL,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      selectrow: {},
      catIds: [],
      // 查询参数
      queryParam: {
        kw: '',
        catId: '',
        status: 'active',
        storeId: '0'
      },
      categoryData: null,
      storeData: [],
      // 表头
      columns: [
        {
          title: '商品编号',
          dataIndex: 'locationNo',
          className: 'text-center'
        },
        {
          title: '商品名称',
          dataIndex: 'name',
          className: 'text-center'
        },
        {
          title: '商品类别',
          dataIndex: 'category.name',
          className: 'text-center'
        },
        {
          title: '规格型号',
          dataIndex: 'type',
          className: 'text-center'
        },
        {
          title: '单位',
          dataIndex: 'unit.name',
          className: 'text-center'
        },
        {
          title: '当前库存',
          dataIndex: 'totalNums',
          className: 'text-right'
        },
        {
          title: '备注',
          dataIndex: 'note'
        },
        {
          title: '状态',
          dataIndex: 'status',
          className: 'text-center',
          scopedSlots: { customRender: 'status' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getGoodsList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.result
          })
      },

      selectedRowKeys: [],
      selectedRows: [],
      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange,
          type: 'radio'
        }
      }

    }
  },
  created () {
    this.loadCategory()
    this.storeData = this.storeList === undefined ? [] : this.storeList
    if (!this.storeData || this.storeData.length <= 0) {
      this.loadStore()
    }
  },
  methods: {

    onChange (val) {
      this.queryParam.catId = val.join(',')
      this.reloadTable()
    },
    reloadTable () {
      this.$refs.table.refresh(true)
    },
    tableSearch () {
      this.$refs.table.refresh(true)
    },
    resetTableSearch () {
      this.queryParam = {
        kw: '',
        catId: '0',
        status: 'active',
        storeId: ''
      }
      this.reloadTable()
    },
    loadCategory () {
      getCategoryGoods({ tree: true })
        .then(res => {
          this.categoryData = res.result
        })
    },
    loadStore () {
      commonStoreList({ all: true }).then(res => {
        this.storeData = res.result.data
      })
    },
    handleOk () {
      this.$emit('handleOk', this.selectedRows)
      this.$refs.table.clearSelected()
    },
    handleCancel () {
      this.$emit('handleCancel')
      this.$refs.table.clearSelected()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    }
  },
  watch: {
  }
}
</script>
<style scoped>

  th.text-right, td.text-right {
    text-align: right !important;
  }
  th.text-center, td.text-center {
    text-align: center !important;
  }
  >>> .ant-select-selection--multiple {
    height: 32px;
    overflow: hidden;
  }
</style>
